import React, { useState } from "react";
import "../index.scss";
import InputField from "./components/inputField";
import MailIcon from "../icons/mail_email.svg";
import KeyIcon from "../icons/key.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import Message from "../message";
import RightIcon from "../icons/rightIcon.svg";
import forge from "node-forge";
import publicKeyPem from "./publicKeyPem";
import ChangePassword from "../../Auth/changePassword";

const RequestOTP = ({ switchToSubmitOTP }) => {
  const [userName, setUserName] = useState("");
  const [passWord, setPassword] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState(null);

  function encryptWithPublicKey(publicKeyPem, plaintext) {
    // Convert PEM public key to forge RSA public key
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    // Encrypt the plaintext using RSA-OAEP with SHA-256
    const encrypted = publicKey.encrypt(plaintext, "RSA-OAEP", {
      md: forge.md.sha256.create(),
      mgf1: forge.mgf.mgf1.create(forge.md.sha256.create()),
    });

    // Return encrypted data as a Base64 string
    return forge.util.encode64(encrypted);
  }

  const changeUserName = (e) => {
    setMessage(null);
    setUserName(e.target.value);
  };

  const changePassword = (e) => {
    setMessage(null);
    setPassword(e.target.value);
  };

  const sendOTPRequest = () => {
    setIsProcessing(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/auth/authenticate-user`, {
        username: encryptWithPublicKey(
          Buffer.from(publicKeyPem, "base64").toString("ascii"),
          userName
        ),
        password: encryptWithPublicKey(
          Buffer.from(publicKeyPem, "base64").toString("ascii"),
          passWord
        ),
      })
      .then((res) => {
        setIsProcessing(false);
        switchToSubmitOTP({
          message: res.data.message,
          user_id: res.data.user,
        });
        //console.log(res.data);
      })
      .catch((err) => {
        setIsProcessing(false);
        if (err.response)
          setMessage({
            text: err.response.data.message,
            color: "rgba(229, 16, 46, 1)",
          });
        else
          setMessage({
            text: "Something went wrong",
            color: "red",
          });
      });
  };

  const handleKeyDown = (e, currentField) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (currentField === "username") {
        // Move focus to password field - we'll need to pass a ref to InputField
        const passwordInput = document.querySelector('input[type="password"]');
        if (passwordInput) {
          passwordInput.focus();
        }
      } else if (currentField === "password") {
        // Submit if both fields are filled
        if (!isButtonDisabled && !isProcessing) {
          sendOTPRequest();
        }
      }
    }
  };

  const isButtonDisabled = !userName || !passWord;
  return (
    <div className="otp-container">
      <div className="otp-header-container">
        <h2>Login</h2>
        <h3>Please login to your account</h3>
      </div>
      <div className="auth-input-fields">
        <InputField
          value={userName}
          onChangeValue={changeUserName}
          label="Username"
          icon={MailIcon}
          onKeyDown={(e) => handleKeyDown(e, "username")}
        />
        <InputField
          value={passWord}
          onChangeValue={changePassword}
          label="Password"
          isPassword
          icon={KeyIcon}
          onKeyDown={(e) => handleKeyDown(e, "password")}
        />

        {message && <Message msg={message?.text} color={message?.color} />}
        <ChangePassword />
      </div>
      <div className="auth-button-container">
        <button
          className="auth-action-button"
          disabled={isButtonDisabled}
          onClick={sendOTPRequest}
        >
          {isProcessing ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <>
              Request OTP
              <img src={RightIcon} alt="right-icon" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default RequestOTP;
